import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import PageLayout from "./common/PageApp";
import JobSearchBar from "../jobseeker/common/JobSearchBar";
import "../../Home.css";
import { toast } from "react-toastify";
import { getCities, getJobList, applyJob, saveJob } from "../../service/api";
import Select from "react-select";
import { useLocation } from "react-router-dom";

const AboutUs = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  return (
    <PageLayout>
      <section className="innerBnrNav">
        <div className="bnrNav">
          <div className="site-width">
            <div className="bnrNavWrap">
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="javascript:void(0)">About Us</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>


      <section className="about-content pt-50 pb-50">
        <div className="site-width">
          <div className="about-card">
          <div className="titleSection text-center wow animate__fadeInDown">
            <h2>About Us</h2>
          </div>
            <p>Welcome to <strong>Hourlee</strong>, a modern platform built to transform the way people connect with work and talent. We understand that the traditional 9-to-5 model doesn’t fit everyone, and businesses often need flexible manpower solutions to meet immediate or short-term requirements. That’s why we created a simple, reliable, and transparent ecosystem where <strong>employers and job seekers come together for hourly-based opportunities.</strong></p>

            <p>In today’s fast-paced world, time is money, and agility is everything. Companies often require extra hands during peak hours, seasonal demand, or special projects, while professionals increasingly seek jobs that offer flexibility, freedom, and fair pay. <strong>Hourlee bridges this gap by enabling businesses to hire skilled workers on an hourly basis and empowering individuals to choose work that suits their schedules and lifestyles.</strong></p>
            <br></br>

          {/* Objectives */}
          <div className="titleSection text-center wow animate__fadeInDown">
            <h2>Our platform is designed with two clear objectives:</h2>
          </div>
          <div className="about-objectives">
            <div className="objective-card">
              <h3>For Employers</h3>
              <p>We provide instant access to a pool of pre-verified candidates across multiple industries and job categories. From retail staff, delivery associates, hospitality workers, and event helpers to technical support and office staff—our system ensures you can quickly find the right talent, save time, and optimize costs. With our smart-matching technology, posting jobs, reviewing applications, and hiring the right person becomes seamless and efficient.</p>
            </div>

            <div className="objective-card">
              <h3>For Job Seekers</h3>
              <p>We offer a world of opportunities where you are in control of when, where, and how much you want to work. Whether you are a student looking to earn extra income, a professional seeking flexible jobs, or someone exploring multiple streams of work, our portal helps you find trusted employers, transparent payouts, and real-time job alerts—ensuring that you can start earning quickly and safely.</p>
            </div>
          </div>
          </div>


          <div className="about-card">
          <div className="titleSection text-center wow animate__fadeInDown">
            <h2>Mission & Vision</h2>
          </div>
              <p>At <strong>Hourlee</strong>, our mission is to create a <strong>future of work that is flexible, accessible, and fair.</strong> We are committed to building trust through verified profiles, secure payment systems, and reliable customer support, ensuring that both employers and employees experience smooth and hassle-free engagement.</p>

              <p>We envision a future where no opportunity goes untapped and no talent goes unnoticed. By breaking the barriers of location, time, and rigid work structures, we strive to empower individuals to work on their own terms and businesses to grow with adaptable manpower solutions.</p>

              <p>With innovation, technology, and human connection at our core, <strong>we are not just a job portal; we are a movement towards a smarter, more inclusive, and flexible world of work.</strong></p>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default AboutUs;